/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_Open_PropertyInputs */

const cs_lead_open_property = /** @type {(inputs: Lead_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitost`)
};

const en_lead_open_property = /** @type {(inputs: Lead_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open property`)
};

/**
* | output |
* | --- |
* | "Open property" |
*
* @param {Lead_Open_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_open_property = /** @type {((inputs?: Lead_Open_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_Open_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_open_property(inputs)
	return cs_lead_open_property(inputs)
});